export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_web-builder-2001/artifacts/88was3sv_WhatsApp%20Image%202026-05-28%20at%2012.48.45%20PM.jpeg';

// Hero & section imagery — Real photos from Agropecuaria Tres Cerritos (WhatsApp 29-may-2026)
// Brangus → animales rojos. Sardo Negro → blancos con negro.
export const IMG = {
  // Hero (portada) — kept as scenic sunset pasture per user instruction
  heroPasture: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=2000&q=80',

  // BRANGUS — toro Brangus de exhibición (foto real Tres Cerritos)
  brangusBull: 'https://customer-assets.emergentagent.com/job_web-builder-2001/artifacts/fw3k1c8v_WhatsApp%20Image%202026-05-29%20at%201.39.50%20PM.jpeg',

  // SARDO NEGRO — toro joven blanco con negro, perfil limpio
  sardoNegro: 'https://customer-assets.emergentagent.com/job_web-builder-2001/artifacts/3cthmjml_WhatsApp%20Image%202026-05-29%20at%201.39.51%20PM%20%283%29.jpeg',

  // Ganado comercial — niño junto al ganado rojo (legado, vínculo humano-animal)
  herd: 'https://customer-assets.emergentagent.com/job_web-builder-2001/artifacts/c2myl4gt_WhatsApp%20Image%202026-05-29%20at%202.45.13%20PM.jpeg',

  // Producción Forrajera — vaca roja pastando
  cornSilage: 'https://customer-assets.emergentagent.com/job_web-builder-2001/artifacts/p33maa0t_WhatsApp%20Image%202026-05-29%20at%201.39.51%20PM%20%281%29.jpeg',

  // Nutrición Inteligente — keep lab/science context
  feedTrough: 'https://images.unsplash.com/photo-1582719471384-894fbb16e074?auto=format&fit=crop&w=1000&q=80',

  // Gestión basada en datos — keep dashboard
  dashboard: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1000&q=80',

  // Sardo Negro adulto — usado como acento en bloque Visión
  sardoAdulto: 'https://customer-assets.emergentagent.com/job_web-builder-2001/artifacts/6yxvtavp_WhatsApp%20Image%202026-05-29%20at%201.39.51%20PM.jpeg',

  // Comedero Inteligente Nexara — infografía / foto del producto
  nexaraFeeder: 'https://customer-assets.emergentagent.com/job_web-builder-2001/artifacts/ce710u77_Nexara%20-%20Smart%20Feeder.png',

  // Logo oficial de Nexara
  nexaraLogo: 'https://customer-assets.emergentagent.com/job_web-builder-2001/artifacts/2bxp5vep_Nexara%20logo%202.png',

  ranchEntrance: 'https://customer-assets.emergentagent.com/job_web-builder-2001/artifacts/mf58epfg_WhatsApp%20Image%202026-05-29%20at%201.39.51%20PM%20%282%29.jpeg',
  mountains: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=2000&q=80',
};
